import React from 'react';
import Icon from '../../../components/AppIcon';
import { useNavigate } from 'react-router-dom';

const DashboardStats = ({ stats, onQuotesReceivedClick }) => {
  const navigate = useNavigate();

  const handleNewMessagesClick = () => {
    navigate('/customer/messages-v2');
  };

  const statItems = [
    {
      label: 'Open Enquiries',
      value: stats?.openEnquiries,
      icon: 'FileText',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      clickable: false
    },
    {
      label: 'New Messages',
      value: stats?.newMessages,
      icon: 'MessageCircle',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      clickable: true,
      onClick: handleNewMessagesClick
    },
    {
      label: 'Quotes Received',
      value: stats?.quotesReceived,
      icon: 'DollarSign',
      color: 'text-success',
      bgColor: 'bg-success/10',
      clickable: true,
      onClick: onQuotesReceivedClick
    },
    {
      label: 'Trips Booked',
      value: stats?.tripsBooked,
      icon: 'CheckCircle',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      clickable: false
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statItems?.map((item, index) => (
        <div 
          key={index} 
          className={`bg-card border border-border rounded-lg p-4 shadow-soft ${
            item?.clickable ? 'cursor-pointer hover:shadow-md transition-shadow' : ''
          }`}
          onClick={item?.clickable ? item?.onClick : undefined}
          role={item?.clickable ? 'button' : undefined}
          tabIndex={item?.clickable ? 0 : undefined}
          onKeyDown={item?.clickable ? (e) => {
            if (e?.key === 'Enter' || e?.key === ' ') {
              e?.preventDefault();
              item?.onClick();
            }
          } : undefined}
        >
          <div className="flex items-center space-x-3">
            <div className={`p-2 rounded-lg ${item?.bgColor}`}>
              <Icon name={item?.icon} size={20} className={item?.color} />
            </div>
            <div>
              <div className="text-2xl font-bold text-foreground">{item?.value}</div>
              <div className="text-sm text-muted-foreground">{item?.label}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStats;